import {
  HomeOutlined,
  SwapOutlined,
  RetweetOutlined,
  StockOutlined,
  FileProtectOutlined,
  CalendarOutlined,
  FormOutlined,
  ScheduleOutlined,
  InfoCircleOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  EnvironmentOutlined,
  OrderedListOutlined,
  RollbackOutlined,
} from '@ant-design/icons';

import Estoque from '../modules/estoque';
import Movimentacoes from '../modules/movimentacoes';
import Logout from '../modules/login/logout';
import { RouteType } from './routeType';
import MeusDados from '../modules/meusDados';
import { ROLE } from '../utils/roles';
import ColetaNoCd from '../modules/agendamentos/submodules/coletaNoCd';
import EntregaNoCd from '../modules/agendamentos/submodules/entregaNoCd';
import GestaoAgendamento from '../modules/dashboards/gestaoAgendamento';
import Motorista from '../modules/cadastros/cadastroMotorista';
import Veiculo from '../modules/cadastros/cadastroVeiculo';
import BlackList from '../modules/cadastros/blackList';
import SolicitacoesRetorno from '../modules/solicitacoesRetorno';
import ConfirmacaoRetorno from '../modules/estoque/components/ConfirmacaoRetorno';
import Agendamentos from '../modules/agendamentos/submodules/agendamentos';
import OrdemCarga from '../modules/agendamentos/submodules/ordemCarga';
import Atendimento from '../modules/atendimento';
import DashboardSla from '../modules/dashboards/sla';
import Ajuda from '../modules/ajuda';
import ajudaAtendimento from '../modules/ajuda/components/atendimento';
import ajudaEstoque from '../modules/ajuda/components/estoque';
import ajudaGeral from '../modules/ajuda/components/geral';
import ajudaMovimentacoes from '../modules/ajuda/components/movimentacoes';
import ajudaSolicitacaoRetorno from '../modules/ajuda/components/solicitacaoRetorno';
import ajudaTracking from '../modules/ajuda/components/tracking';
import Tracking from '../modules/tracking';
import CargaDescarga from '../modules/dashboards/cargaDescarga';
import Devolucao from '../modules/devolucao';

export const movimentacoesRoute: RouteType = {
  path: '/movimentacoes',
  name: 'Movimentações',
  component: Movimentacoes,
  layout: '/dashboard',
  isPrivate: true,
  icon: SwapOutlined,
  roles: [ROLE.ADMINISTRADOR, ROLE.DEPOSITANTE, ROLE.FORNECEDOR, ROLE.ANALISTACD],
};

export const estoqueRoute: RouteType = {
  path: '/estoque',
  name: 'Estoque',
  component: Estoque,
  layout: '/dashboard',
  isPrivate: true,
  icon: StockOutlined,
  roles: [ROLE.ADMINISTRADOR, ROLE.DEPOSITANTE, ROLE.FORNECEDOR, ROLE.ANALISTACD],
};

export const solicitacoesRetornoRoute: RouteType = {
  path: '/solicitacoesderetorno',
  name: 'Solicitações de retorno',
  component: SolicitacoesRetorno,
  layout: '/dashboard',
  isPrivate: true,
  icon: RetweetOutlined,
  roles: [ROLE.ADMINISTRADOR, ROLE.DEPOSITANTE, ROLE.FORNECEDOR, ROLE.ANALISTACD],
};

export const confirmacaoRetornoRoute: RouteType = {
  path: '/confirmRetorno',
  name: 'Confirmação de retorno',
  component: ConfirmacaoRetorno,
  layout: '/dashboard',
  isPrivate: true,
  icon: StockOutlined,
  roles: [ROLE.ADMINISTRADOR, ROLE.DEPOSITANTE, ROLE.FORNECEDOR, ROLE.ANALISTACD],
};

/*Área de agendamentos*/

export const entregaNoCdRoute: RouteType = {
  path: '/entregaNocd',
  name: 'Entregas no CD',
  component: EntregaNoCd,
  layout: '/dashboard',
  isPrivate: true,
  icon: CalendarOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
    ROLE.TRANSPORTADORA,
    ROLE.ANALISTACD,
  ],
};

export const coletaNoCdRoute: RouteType = {
  path: '/coletanocd',
  name: 'Coletas no CD',
  component: ColetaNoCd,
  layout: '/dashboard',
  isPrivate: true,
  icon: FileProtectOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
    ROLE.TRANSPORTADORA,
    ROLE.ANALISTACD,
  ],
};

export const ordemCargaRoute: RouteType = {
  path: '/ordemCarga',
  name: 'Ordens de carga',
  component: OrdemCarga,
  layout: '/dashboard',
  isPrivate: true,
  icon: CalendarOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
    ROLE.TRANSPORTADORA,
    ROLE.ANALISTACD,
  ],
};

export const agendamentosRoute: RouteType = {
  path: '/agendamentos',
  name: 'Agendamentos',
  component: Agendamentos,
  layout: '/dashboard',
  isPrivate: true,
  icon: CalendarOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
    ROLE.TRANSPORTADORA,
    ROLE.ANALISTACD,
  ],
};

export const AgendamentoRoute: RouteType = {
  path: '/',
  name: 'Área de agendamentos',
  layout: '/dashboard',
  isPrivate: true,
  icon: ScheduleOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
    ROLE.TRANSPORTADORA,
    ROLE.ANALISTACD,
  ],
  submenu: [entregaNoCdRoute, coletaNoCdRoute, ordemCargaRoute, agendamentosRoute],
};

/*Cadastro*/

export const CadastroMotoristaRoute: RouteType = {
  path: '/motorista',
  name: 'Motoristas',
  component: Motorista,
  layout: '/dashboard',
  isPrivate: true,
  icon: CalendarOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.TRANSPORTADORA,
    ROLE.ANALISTACD,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
  ],
};

export const CadastroVeiculoRoute: RouteType = {
  path: '/veiculo',
  name: 'Veículos',
  component: Veiculo,
  layout: '/dashboard',
  isPrivate: true,
  icon: CalendarOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.TRANSPORTADORA,
    ROLE.ANALISTACD,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
  ],
};

export const BlockListRoute: RouteType = {
  path: '/blacklist',
  name: 'Blocklist',
  component: BlackList,
  layout: '/dashboard',
  isPrivate: true,
  icon: OrderedListOutlined,
  roles: [ROLE.ADMINISTRADOR, ROLE.ANALISTACD],
};

export const CadastroRoute: RouteType = {
  path: '/',
  name: 'Cadastros',
  layout: '/dashboard',
  isPrivate: true,
  icon: FormOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.ANALISTACD,
    ROLE.TRANSPORTADORA,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
  ],
  submenu: [BlockListRoute, CadastroMotoristaRoute, CadastroVeiculoRoute],
};
export const logoutRoute: RouteType = {
  path: '/logout',
  name: 'Logout',
  component: Logout,
  layout: '/dashboard',
  isPrivate: true,
  icon: HomeOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
    ROLE.TRANSPORTADORA,
    ROLE.ANALISTACD,
  ],
};

export const meusDados: RouteType = {
  path: '/meusdados',
  name: 'Meus Dados',
  component: MeusDados,
  layout: '/dashboard',
  isPrivate: true,
  icon: HomeOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
    ROLE.TRANSPORTADORA,
    ROLE.ANALISTACD,
  ],
};

export const atendimentoRoute: RouteType = {
  path: '/atendimento',
  name: 'Atendimento',
  component: Atendimento,
  layout: '/dashboard',
  isPrivate: true,
  icon: CustomerServiceOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
    ROLE.TRANSPORTADORA,
    ROLE.ANALISTACD,
  ],
};

/*Ajuda*/

export const AjudaRoute: RouteType = {
  path: '/ajuda',
  name: 'Ajuda',
  component: Ajuda,
  layout: '/dashboard',
  isPrivate: true,
  icon: InfoCircleOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
    ROLE.ANALISTACD,
    ROLE.TRANSPORTADORA,
  ],
};

export const AjudaRouteAtendimento: RouteType = {
  path: '/ajuda/atendimento',
  name: 'ajudaAtendimento',
  component: ajudaAtendimento,
  layout: '/dashboard',
  isPrivate: true,
  icon: InfoCircleOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
    ROLE.ANALISTACD,
    ROLE.TRANSPORTADORA,
  ],
};

export const AjudaRouteEstoque: RouteType = {
  path: '/ajuda/estoque',
  name: 'ajudaEstoque',
  component: ajudaEstoque,
  layout: '/dashboard',
  isPrivate: true,
  icon: InfoCircleOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
    ROLE.ANALISTACD,
    ROLE.TRANSPORTADORA,
  ],
};

export const AjudaRouteGeral: RouteType = {
  path: '/ajuda/geral',
  name: 'ajudaGeral',
  component: ajudaGeral,
  layout: '/dashboard',
  isPrivate: true,
  icon: InfoCircleOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
    ROLE.ANALISTACD,
    ROLE.TRANSPORTADORA,
  ],
};

export const AjudaRouteMovimentacoes: RouteType = {
  path: '/ajuda/movimentacoes',
  name: 'ajudaMovimentacoes',
  component: ajudaMovimentacoes,
  layout: '/dashboard',
  isPrivate: true,
  icon: InfoCircleOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
    ROLE.ANALISTACD,
    ROLE.TRANSPORTADORA,
  ],
};

export const AjudaSolicitacaoRetorno: RouteType = {
  path: '/ajuda/solicitacaoretorno',
  name: 'ajudaSolicitacaoRetorno',
  component: ajudaSolicitacaoRetorno,
  layout: '/dashboard',
  isPrivate: true,
  icon: InfoCircleOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
    ROLE.ANALISTACD,
    ROLE.TRANSPORTADORA,
  ],
};

export const AjudaRouteTracking: RouteType = {
  path: '/ajuda/tracking',
  name: 'ajudaTracking',
  component: ajudaTracking,
  layout: '/dashboard',
  isPrivate: true,
  icon: InfoCircleOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
    ROLE.ANALISTACD,
    ROLE.TRANSPORTADORA,
  ],
};

/*Dashboard */

export const dashboardSlaRoute: RouteType = {
  path: '/dash/sla',
  name: 'SLA',
  component: DashboardSla,
  layout: '/dashboard',
  isPrivate: true,
  icon: DashboardOutlined,
  roles: [ROLE.ADMINISTRADOR],
};

export const dashCargaDescargaRoute: RouteType = {
  path: '/cargaDescarga',
  name: 'Expedição e recebimento',
  component: CargaDescarga,
  layout: '/dashboard',
  isPrivate: true,
  icon: HomeOutlined,
  roles: [ROLE.ADMINISTRADOR],
};

export const calendarioRoute: RouteType = {
  path: '/consultaagendamento',
  name: 'Consultar agendamentos',
  component: GestaoAgendamento,
  layout: '/dashboard',
  isPrivate: true,
  icon: CalendarOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
    ROLE.TRANSPORTADORA,
    ROLE.ANALISTACD,
  ],
};

export const DashboardRoute: RouteType = {
  path: '/',
  name: 'Dashboards',
  layout: '/dashboard',
  isPrivate: true,
  icon: DashboardOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.ANALISTACD,
    ROLE.TRANSPORTADORA,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
  ],
  submenu: [calendarioRoute, dashCargaDescargaRoute, dashboardSlaRoute],
};

export const trackingRoute: RouteType = {
  path: '/tracking',
  name: 'Tracking',
  component: Tracking,
  layout: '/dashboard',
  isPrivate: true,
  icon: EnvironmentOutlined,
  roles: [
    ROLE.ADMINISTRADOR,
    ROLE.DEPOSITANTE,
    ROLE.FORNECEDOR,
    ROLE.TRANSPORTADORA,
    ROLE.ANALISTACD,
  ],
};

export const devolucaoRoute: RouteType = {
  path: '/devolucao',
  name: 'Devolução',
  component: Devolucao,
  layout: '/dashboard',
  isPrivate: true,
  icon: RollbackOutlined,
  roles: [ROLE.ADMINISTRADOR, ROLE.ANALISTACD],
};
